import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { setQuestion } from 'src/app/actions/question.actions';
import { Candidate } from 'src/app/models/candidate.model';
import { Question } from 'src/app/models/question.model';
import { Test } from 'src/app/models/test.model';
import { fromCandidate } from 'src/app/reducers/candidate.reducer';
import { fromQuestion } from 'src/app/reducers/question.reducer';
import { fromTest } from 'src/app/reducers/test.reducer';
import { CustomSelectService } from 'src/app/services/customSelect.service';
import { QuestionService } from 'src/app/services/question.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'ct-reasoning-instruction',
  templateUrl: './reasoning-instruction.component.html',
  styleUrls: ['./reasoning-instruction.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ReasoningInstructionComponent implements OnInit {

  @Input() colors: any;

  public question$: Observable<Question>;
  public test$: Observable<Test>;

  public instructionsPageNumber = 0;
  public currentCandidate: Candidate;
  public currentTest: Test;
  public currentLanguage: string;
  public languagesNotSelected: string[];

  constructor(
    private store: Store,
    private questionService: QuestionService,
    private utilsService: UtilsService,
    private translateService: TranslateService,
    public customSelectService: CustomSelectService
  ) { }

  ngOnInit(): void {

    // obtenemos los datos de la pregunta y el test de la store
    this.test$ = this.store.pipe(select(fromTest.selectTestState));
    this.question$ = this.store.pipe(select(fromQuestion.selectQuestionState));

    this.test$.subscribe(test => {
      if (test) {
        this.currentCandidate = test.candidate;
        this.currentTest = test;
        this.currentLanguage = this.utilsService.getLanguageFromLanguageId(test.invitation.languageId);
        this.translateService.use(this.currentLanguage);
        document.documentElement.lang = this.currentLanguage.split('-')[0];
      }
    });

  }

  /**
   * Avanza en las páginas de instrucciones
   */
  public nextInstructionsPage() {
    window.scroll(0, 0);
    // si es la ultima página de instrucciones se pasa al ejemplo de módulo/nivel
    if (this.instructionsPageNumber === 4) {
      this.question$.pipe(take(1)).subscribe(currentQuestion => {
        this.store.dispatch(setQuestion({ ...currentQuestion, levels: [] }));
      });
    } else {
      this.instructionsPageNumber++;
    }
  }

  /**
   * Retrocede en las páginas de instrucciones
   */
  public previousInstructionsPage() {
    window.scroll(0, 0);
    if (this.instructionsPageNumber !== 0) {
      this.instructionsPageNumber--;
    }
  }

  /**
   * cambio de idioma de todas laspruebas del candidato
   */
  public changeLanguage(language) {
    this.utilsService.changeLanguage(language, this.currentCandidate.id).subscribe(res => {
      this.currentLanguage = language;
    });
  }

  /**
   * muestra/oculta el sleccionable de idiomas responsive
   */
  public toogleLanguageSelect(action: string) {
    // actualizamos de los idiomas no seleccionados
    this.languagesNotSelected = this.utilsService.getLanguagesNotSelected(this.currentTest?.clientId);

    // se ejecuta la cción que corresponda
    switch (action) {
      case 'toogle':
        this.customSelectService.toogleLanguageSelect('toogle');
        break;
      case 'false':
        this.customSelectService.toogleLanguageSelect('false');
        break;
      default:
        this.customSelectService.toogleLanguageSelect('toogle');
        break;
    }
  }

}
